import React, { useState } from "react";
import learningData from "../data/private/learning.json";
import { logActivity } from "../utils/activity";

export default function DashboardLearn() {
  const [active, setActive] = useState(null);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-slate-900">
          {learningData.title}
        </h1>
        <p className="mt-2 text-sm text-slate-600">{learningData.subtitle}</p>
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        {learningData.items.map((item) => (
          <div key={item.title} className="card card-hover p-4">
            <p className="text-sm font-semibold text-slate-900">{item.title}</p>
            <p className="mt-2 text-sm text-slate-600">{item.description}</p>
            <p className="mt-2 text-xs text-slate-500">{item.readTime}</p>
            <button
              className="btn btn-secondary mt-4"
              onClick={() => {
                setActive(item);
                logActivity("learn_open", { title: item.title });
              }}
            >
              {item.title}
            </button>
          </div>
        ))}
      </div>

      {active && (
        <div className="card p-6">
          <p className="text-sm font-semibold text-slate-900">{active.title}</p>
          <p className="mt-2 text-sm text-slate-600">{active.description}</p>
          <p className="mt-2 text-xs text-slate-500">{active.readTime}</p>
          <button
            className="btn btn-secondary mt-4"
            onClick={() => setActive(null)}
          >
            {learningData.title}
          </button>
        </div>
      )}
    </div>
  );
}
